var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMagazineWhiteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.495,
    height: 20.23,
    viewBox: "0 0 19.495 20.23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2340",
    "data-name": "Trac\\xE9 2340",
    d: "M-2081.311,2135.967h-5.3a1.275,1.275,0,0,0-.183.018,1.278,1.278,0,0,0-.183-.018h-5.3a4.268,4.268,0,0,0-4.263,4.264v11.7a4.268,4.268,0,0,0,4.263,4.264h5.3a1.314,1.314,0,0,0,.183-.018,1.311,1.311,0,0,0,.183.018h5.3a4.268,4.268,0,0,0,4.263-4.264v-11.7A4.268,4.268,0,0,0-2081.311,2135.967Zm-12.628,15.966v-11.7a1.662,1.662,0,0,1,1.659-1.66h.989a7.487,7.487,0,0,1,5.854,2.81,7.58,7.58,0,0,1,1.47,6.4,7.693,7.693,0,0,1-7.621,5.808h-.692A1.662,1.662,0,0,1-2093.938,2151.933Zm14.288,0a1.662,1.662,0,0,1-1.66,1.66h-3.276a9.721,9.721,0,0,0,3.165-5.251,10.172,10.172,0,0,0-1.986-8.593,10.2,10.2,0,0,0-1.135-1.179h3.232a1.662,1.662,0,0,1,1.66,1.66Z",
    transform: "translate(2096.542 -2135.967)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagazineWhiteIcon);
export default __webpack_public_path__ + "static/media/magazineWhiteIcon.5b073a9cac15c1c7c13a4d4152e96e79.svg";
export { ForwardRef as ReactComponent };